import moment from "moment";
export var formatDateTime = function (dateString) {
    if (!dateString)
        return "N/A";
    return moment(dateString).format('DD.MM.YYYY HH:mm');
};
export var formatDate = function (dateString) {
    return moment(dateString).format('DD.MM.YYYY');
};
